import { render, staticRenderFns } from "./InvoicePreview.vue?vue&type=template&id=68598497&scoped=true"
import script from "./InvoicePreview.vue?vue&type=script&lang=ts"
export * from "./InvoicePreview.vue?vue&type=script&lang=ts"
import style0 from "./InvoicePreview.vue?vue&type=style&index=0&id=68598497&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68598497",
  null
  
)

export default component.exports